// Centralized partners list — used by Landing, PassportDetail and About pages.
export const PARTNERS = [
  {
    name: "SeaLife",
    logo: "https://customer-assets.emergentagent.com/job_f049ee2b-edae-4cc4-8e76-bfc796e90f9f/artifacts/d6y6z5j7_Logo_Sealife.png",
  },
  {
    name: "SeaTrips",
    logo: "https://customer-assets.emergentagent.com/job_f049ee2b-edae-4cc4-8e76-bfc796e90f9f/artifacts/5wfqgfjp_logo_seatrips.png",
  },
  {
    name: "Bom Dia Lagos",
    logo: "https://customer-assets.emergentagent.com/job_f049ee2b-edae-4cc4-8e76-bfc796e90f9f/artifacts/x6luo2l4_logomarca-bom-dia.png",
  },
  {
    name: "Bonvivant Café",
    logo: "https://customer-assets.emergentagent.com/job_f049ee2b-edae-4cc4-8e76-bfc796e90f9f/artifacts/ql3v4bwi_logo-bon-vivant.png",
  },
  {
    name: "Parque Aventura",
    logo: "https://customer-assets.emergentagent.com/job_f049ee2b-edae-4cc4-8e76-bfc796e90f9f/artifacts/yeuypmbp_logomarca-parqueaventura.png",
  },
  {
    name: "Zoo de Lagos",
    logo: "https://customer-assets-0z36b82j.emergentagent.net/job_f049ee2b-edae-4cc4-8e76-bfc796e90f9f/artifacts/lo2o4vju_zoo-lagos-logo-1.jpg",
  },
];

/**
 * PartnerLogos — uniform partner-logo strip.
 *   - Each logo lives in a fixed 160×80 box (so aspect ratios don't make
 *     wider logos look bigger than taller ones).
 *   - object-contain + max-h/max-w keeps the artwork intact and centered.
 *   - Subtle hover scale gives life without breaking the grid.
 */
export default function PartnerLogos({ className = "", boxClassName = "" }) {
  return (
    <div className={`grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-6 items-center justify-items-center ${className}`}>
      {PARTNERS.map((p) => (
        <div
          key={p.name}
          className={`w-full h-20 flex items-center justify-center transition-transform duration-300 hover:scale-110 ${boxClassName}`}
          title={p.name}
        >
          <img
            src={p.logo}
            alt={p.name}
            className="max-h-16 max-w-full object-contain"
            loading="lazy"
            onError={(e) => { e.target.style.display = "none"; }}
          />
        </div>
      ))}
    </div>
  );
}
